import { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";
import { ContactButtons } from "../../ContactButtons";
import { InlineCustomerForm } from "../forms/InlineCustomerForm";
import type { OrderFormData, CustomerOption, CustomerFormData, OrderTrackingInfo } from "../types";
import { getCustomerDisplayName } from "../types";

interface CustomerSectionProps {
  form: UseFormReturn<OrderFormData>;
  customers: CustomerOption[] | undefined;
  orderId?: string;
  orderTrackingInfo: OrderTrackingInfo | null;
  isCreating: boolean;
  setIsCreating: (value: boolean) => void;
  formData: CustomerFormData;
  setFormData: (data: CustomerFormData) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export function CustomerSection({
  form,
  customers,
  orderId,
  orderTrackingInfo,
  isCreating,
  setIsCreating,
  formData,
  setFormData,
  onSubmit,
  isSubmitting,
}: CustomerSectionProps) {
  if (isCreating) {
    return (
      <InlineCustomerForm
        formData={formData}
        onChange={setFormData}
        onSubmit={onSubmit}
        onCancel={() => setIsCreating(false)}
        isSubmitting={isSubmitting}
      />
    );
  }

  return (
    <>
      <FormField
        control={form.control}
        name="customer_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Asiakas *</FormLabel>
            <div className="flex items-center gap-2">
              <Select onValueChange={field.onChange} value={field.value}>
                <FormControl>
                  <SelectTrigger className="flex-1">
                    <SelectValue placeholder="Valitse asiakas" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {customers?.map((customer) => (
                    <SelectItem key={customer.id} value={customer.id}>
                      {getCustomerDisplayName(customer)}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {field.value && (() => {
                const customer = customers?.find((c) => c.id === field.value);
                if (!customer) return null;
                const name = getCustomerDisplayName(customer) || "Asiakas";
                return (
                  <ContactButtons
                    phone={customer.phone}
                    email={customer.email}
                    customerName={name}
                    orderId={orderId}
                    customerId={customer.id}
                    orderNumber={orderTrackingInfo?.order_number}
                  />
                );
              })()}
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setIsCreating(true)}
        className="w-full"
      >
        <Plus className="mr-2 h-4 w-4" />
        Luo uusi asiakas
      </Button>
    </>
  );
}
